import React, { useState, RefObject } from "react";
import { useServices } from "../../services/Services";
import Dialog from "./Dialog";
import { DialogHandle } from "./DialogTypes";
import css from "../../common-styling/Dialog.module.css";
import { useDeepDiveToast } from "../../context/DeepDiveToastContext";

const TopicDeepDiveDialog: React.FC<{ ref: RefObject<DialogHandle | null> }> =
  function ({ ref }) {
    const [topic, setTopic] = useState<string>("");
    const services = useServices();
    const { data: user } = services.User.useGetCurrent();
    const { showTopicDeepDiveToast } = useDeepDiveToast();

    const createTopicDeepDiveMutation =
      services.Request.useCreateTopicDeepDiveRequest();

    async function createTopicDeepDive() {
      if (!topic || topic.length < 30) {
        alert("Please enter a topic with at least 30 characters");
        return true;
      }
      await createTopicDeepDiveMutation.mutateAsync({
        topic: topic,
        userId: user!.id,
      });
      showTopicDeepDiveToast(topic);
      setTopic("");
      return false; // Close dialog after successful submission
    }

    function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
      setTopic(e.target.value);
    }

    return (
      <Dialog
        className={css.dialog}
        ref={ref}
        title="New Topic Deep Dive"
        action="Create Deep Dive"
        onSubmit={createTopicDeepDive}
        onError={() =>
          "Something went wrong creating your topic deep dive. If the problem persists, please contact accounts@unrulycorp.com."
        }
        buttonsInHeader={true}
      >
        <div className={css.explanation}>
          <span>
            Enter a topic for deep dive analysis. Minimum 30 characters
            required.
          </span>
        </div>
        <div className={css["field-group"]}>
          <div className={css["field"]}>
            <input
              className={css["search-input"]}
              name="topic"
              type="text"
              placeholder="Enter a topic for deep dive analysis (minimum 30 characters)"
              required
              autoComplete="off"
              value={topic}
              ref={(ref) => ref?.setAttribute("autofocus", "true")}
              onChange={handleInputChange}
            />
          </div>
        </div>
      </Dialog>
    );
  };

export default TopicDeepDiveDialog;
